import { useEffect } from 'react'

const preloadedImages = new Map()

export function preloadImages(imageSources = []) {
  if (!Array.isArray(imageSources) || typeof Image === 'undefined') {
    return
  }

  imageSources.forEach((imageSource) => {
    if (!imageSource || preloadedImages.has(imageSource)) {
      return
    }

    const image = new Image()
    preloadedImages.set(imageSource, image)

    image.onerror = () => {
      preloadedImages.delete(imageSource)
    }

    image.src = imageSource
  })
}

export default function usePreloadImages(imageSources = []) {
  useEffect(() => {
    preloadImages(imageSources)
  }, [imageSources])
}
